import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";
import { Skeleton } from "../ui/skeleton";
import { intFmt, pct, usd } from "../../lib/format";

const PLATFORM_LABELS = { web: "Web", ios: "iOS", android: "Android" };

export default function PlatformBreakdownTable({ rows, loading }) {
  return (
    <Card data-testid="platform-breakdown-table">
      <CardHeader>
        <CardTitle className="font-display text-base">Platform breakdown</CardTitle>
        <p className="text-xs text-muted-foreground mt-1">
          Per-store comparison across the selected period.
        </p>
      </CardHeader>
      <CardContent className="px-0 md:px-2">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Platform</TableHead>
                <TableHead className="text-right">New subs</TableHead>
                <TableHead className="text-right">Active subs</TableHead>
                <TableHead className="text-right">Revenue</TableHead>
                <TableHead className="text-right">Renewal</TableHead>
                <TableHead className="text-right">Churn</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {loading
                ? [0, 1, 2].map((i) => (
                    <TableRow key={i}>
                      {[0, 1, 2, 3, 4, 5].map((j) => (
                        <TableCell key={j}>
                          <Skeleton className="h-4 w-16" />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                : rows?.map((r) => (
                    <TableRow key={r.platform} data-testid={`breakdown-row-${r.platform}`}>
                      <TableCell className="font-medium">{PLATFORM_LABELS[r.platform]}</TableCell>
                      <TableCell className="text-right num">{intFmt(r.new_subscriptions)}</TableCell>
                      <TableCell className="text-right num">{intFmt(r.active_subscribers)}</TableCell>
                      <TableCell className="text-right num">{usd(r.revenue_usd)}</TableCell>
                      <TableCell className="text-right num">{pct(r.renewal_rate)}</TableCell>
                      <TableCell className="text-right num">{pct(r.churn_rate)}</TableCell>
                    </TableRow>
                  ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
}
